import { transformTSIntoNaturalDate } from 'plugin-codaf-risk-ext-bowtie/utils'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from 'plugin-codaf-risk-ext-bowtie/utils/constants'

export interface IDraExportFilters {
    entityType: string
    acceptEmptyArguments?: string
}

export const DraExportData = async (params?: IDraExportFilters): Promise<void> => {
    const qs = new URLSearchParams({
        entityType: params?.entityType?.toString(),
        acceptEmptyArguments: params?.acceptEmptyArguments?.toString() ?? ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.export}/CSV/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(async response => {
            if (response.ok) {
                return response.blob()
            } else {
                let jsonData
                try {
                    jsonData = await response.json()
                } catch (err) {
                    jsonData = undefined
                }
                throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
            }
        })
        .then(blob => {
            try {
                const time = new Date()

                // link.href = url

                // link.setAttribute(
                //     'download',

                // )
                // document.body.appendChild(link)

                // link.click()

                // link.parentNode.removeChild(link)
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.setAttribute('href', url)
                a.setAttribute(
                    'download',
                    `${params.entityType} export ${transformTSIntoNaturalDate(time.getTime())}.csv`
                )
                a.click()
                URL.revokeObjectURL(url)
            } catch (error) {
                console.log(error)
            }
        })
}

export const DraExportDataXLS = async (params?: IDraExportFilters): Promise<void> => {
    const qs = new URLSearchParams({
        entityType: params?.entityType?.toString(),
        acceptEmptyArguments: params?.acceptEmptyArguments?.toString() ?? ''
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.export}/XLS/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(async response => {
            if (response.ok) {
                return response.blob()
            } else {
                let jsonData
                try {
                    jsonData = await response.json()
                } catch (err) {
                    jsonData = undefined
                }
                throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
            }
        })
        .then(blob => {
            try {
                const time = new Date()

                // link.href = url

                // link.setAttribute(
                //     'download',

                // )
                // document.body.appendChild(link)

                // link.click()

                // link.parentNode.removeChild(link)
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.setAttribute('href', url)
                a.setAttribute(
                    'download',
                    `${params.entityType} export ${transformTSIntoNaturalDate(time.getTime())}.xlsx`
                )
                a.click()
                URL.revokeObjectURL(url)
            } catch (error) {
                console.log(error)
            }
        })
}
